<script lang="ts">
    import { replace } from 'svelte-spa-router'
    import Summary from '../components/Summary.svelte'
    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'
    import { t } from '../lib/i18n/t';

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider

    if (null === dataProvider.activityId) {
        void replace("/")
    }
</script>

<div class="bno-container bno-container--spread-min bno-container--centered">
    <div class="bno-container__content">
        <h2>{t("success.hotovo")}</h2>
        <p>
            {t("success.gratulujemeVaseObjednavkaJeUspesneDokoncena")}
        </p>
        <p>
            <strong>
                {t("success.budemeSeNaVasTesit")} <br/>
                {t("success.mejteSeKrasne")}
            </strong>
        </p>
        <Summary {dataProvider} {serviceProvider} update={false}/>
    </div>
</div>
